import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ConfigurationContext } from "../contexts/configurationContext";

/** Until the site config arrives the static title from index.html stays. */
export const useSiteDocumentTitle = () => {
  const siteName = useContext(ConfigurationContext)?.configuration?.merchant.name;
  const { t } = useTranslation();

  useEffect(() => {
    if (siteName) document.title = t("document_title", { site: siteName });
  }, [siteName, t]);
};
